import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@rdkmaster/ngx-translate-core";
import { TranslateHelper } from "@rdkmaster/jigsaw";
import { UnLoggedIn } from "./login";
@NgModule({
    declarations: [UnLoggedIn],
    exports: [UnLoggedIn],
    imports: [CommonModule, TranslateModule.forChild()]
})
export class UnLoggedInModule {
    constructor() {
        TranslateHelper.initI18n("login", {
            zh: {
                info: "\u60A8\u5C1A\u672A\u767B\u5F55\uFF0C\u8BF7\u70B9\u51FB\u8FD9\u91CC",
                login: "\u767B\u5F55"
            },
            en: {
                info: "You have not logged in yet. Please click here to",
                login: " log in "
            }
        });
    }
}
